import { Button, Stack, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import { PageEventFragment } from 'types/api/dato-operations.types';

interface Props {
  event: PageEventFragment;
  onClose: () => void;
}

function RussianUserNotice({ event, onClose }: Props) {
  const { yandexUrl } = event;

  const typographyStyle = { mb: 2 };

  return (
    <Stack
      sx={{
        gap: 2,
      }}
    >
      <Typography sx={typographyStyle}>
        <FormattedMessage id="event.notice.russian.supported" />
        <br />
        <FormattedMessage id="event.notice.russian.ticket.direct" />
      </Typography>
      <Typography sx={typographyStyle}>
        <FormattedMessage id="event.notice.russian.international" />
      </Typography>
      <Typography
        sx={{
          mb: 2,
        }}
      >
        <FormattedMessage id="event.notice.russian.supported.ru" />
        <br />
        <FormattedMessage id="event.notice.russian.ticket.direct.ru" />
      </Typography>
      <Typography sx={typographyStyle}>
        <FormattedMessage id="event.notice.russian.international.ru" />
      </Typography>
      {yandexUrl && (
        <Button
          fullWidth
          variant="outlined"
          color="secondary"
          href={yandexUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          <FormattedMessage id="event.notice.russian.yandex.button" />
        </Button>
      )}
      <Button
        variant="text"
        color="primary"
        sx={{
          textTransform: 'uppercase',
        }}
        onClick={onClose}
      >
        <FormattedMessage id="event.notice.russian.nofomo.button" />
      </Button>
    </Stack>
  );
}

export default RussianUserNotice;
